var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 74.82,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    fillRule: "evenodd",
    d: "m51.58641,43.9c5.45368,-3.55 5.43381,-7.5 0,-10.64l-42.64597,-31.4c-4.42056,-2.8 -9.05966,-1.15 -8.94045,4.69l0.17881,61.68c0.37749,6.34 3.97354,8.07 9.26827,5.14l42.13934,-29.47zm53.55332,-43.9l13.01333,0a3.97354,4 0 0 1 3.91393,3.94l0,66.94a3.97354,4 0 0 1 -3.91393,3.94l-13.01333,0a3.97354,4 0 0 1 -3.91393,-3.94l0,-66.94a3.97354,4 0 0 1 3.91393,-3.94zm-33.67571,0l12.97359,0a3.97354,4 0 0 1 3.97354,3.94l0,66.94a3.97354,4 0 0 1 -3.97354,3.94l-12.97359,0a3.97354,4 0 0 1 -3.91393,-3.94l0,-66.94a3.97354,4 0 0 1 3.91393,-3.94z",
    className: "cls-1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.b99bb127a4dc17bbca2625dad04fe6bf.svg";
export { ForwardRef as ReactComponent };